import type { FunctionComponent } from 'preact';
import styles from './Popup.module.scss';

interface Props {
  name?: string;
  title: string;
  message: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmText?: string;
}

export const Popup: FunctionComponent<Props> = (props) => {
  const { name = '', title, message, confirmText } = props;

  return (
    <div class={`${styles.popup} ${name}`}>
      <div class={styles.modalShadow} />
      <div class={styles.popupContainer}>
        <div class={styles.popupTitle}>{title}</div>
        <div class={styles.popupContents}>
          <div
            class={styles.popupMessage}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: message }}
          />
          {props.children && (
            <div class={styles.popupSubMessage}>{props.children}</div>
          )}
        </div>
        <div class={styles.buttons}>
          {props.onCancel && (
            <a
              href="#"
              class={styles.btnCancel}
              onClick={() => {
                if (typeof props.onCancel === 'function') props.onCancel();
              }}
            >
              취소
            </a>
          )}
          {props.onConfirm && (
            <a
              href="#"
              class={styles.btnConfirm}
              onClick={() => {
                if (typeof props.onConfirm === 'function') props.onConfirm();
              }}
            >
              {confirmText ? confirmText : '확인'}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
